import { render, staticRenderFns } from "./appointmentPage.vue?vue&type=template&id=451e8fee&scoped=true"
import script from "./appointmentPage.vue?vue&type=script&lang=js"
export * from "./appointmentPage.vue?vue&type=script&lang=js"
import style0 from "./appointmentPage.vue?vue&type=style&index=0&id=451e8fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e8fee",
  null
  
)

export default component.exports